import { Box } from '@mui/material';
import KeyboardArrowRightIcon from 'mdi-react/TickIcon';
import { func, object } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';
import Item from '../Item';
import SelectTitle from '../SelectTitle';

const MobileNotifications = props => {
  const {
    settings: { dnd, isOpenCommunication },
    onChange,
  } = props;

  let notificationsCheckedValue = 'Restricted';
  if (dnd) {
    notificationsCheckedValue = 'Never';
  } else if (isOpenCommunication) {
    notificationsCheckedValue = 'Always';
  }
  const radioProps = ['Never', 'Always', 'Restricted'].map(value => ({
    label: I18n.t(`SettingsDrawer.Notifications_${value}`),
    value,
  }));

  return (
    <Box sx={{ pr: '20px' }}>
      <SelectTitle headline={I18n.t('SettingsDrawer.Mobile_Notifications')} />
      {radioProps.map(obj => (
        <Item
          key={obj.label}
          headline={obj.label}
          checkbox={
            notificationsCheckedValue === obj.value ? (
              <Box sx={{ color: 'primary.main' }}>
                <KeyboardArrowRightIcon />
              </Box>
            ) : null
          }
          onClick={() => onChange(obj.value)}
        />
      ))}
    </Box>
  );
};

MobileNotifications.propTypes = {
  settings: object.isRequired,
  onChange: func.isRequired,
};

export default MobileNotifications;
